/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Warden } from './warden';

let hasRouterError = false;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private injector: Injector,
        private http: HttpClient,
        private warden: Warden
    ) {
    }

    /**
     * Handle the error.
     * @param {Error} err
     */
    //  TODO review this file
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public handleError(err: any): void {
        // Load our service via an injector otherwise death
        // const log = this.injector.get<LogService>(LogService as Type<LogService>);
        // const loading = this.injector.get(LoadingService);
        // const location = this.injector.get(LocationStrategy);
        // let user = null;
        // try {
        //     const userService = this.injector.get<UserService>(UserService as Type<UserService>);
        //     user = userService.getUser('email');
        // } catch (error) {
        //     // eslint-disable-next-line no-console
        //     console.log('GlobalErrorHandler:RouterErrorHandler(): error injecting userService');
        // }

        // Our custom logger
        // log.error('ErrorHandler', err.message, {
        //     title: err.name || null,
        //     user,
        //     time: new Date().getTime(),
        //     url: location instanceof PathLocationStrategy ? location.path() : '',
        //     message: err.message || err.toString(),
        //     stack: err instanceof HttpErrorResponse ? null : StackTraceParser.parse(err),
        // });
    }
}

export function MyRouterErrorHandler(error: any) {
    // eslint-disable-next-line no-console
    console.log('GlobalErrorHandler:RouterErrorHandler(): ', error);
    hasRouterError = true;
    throw error;
}

@Injectable()
export class PreventErrorRouteReuseStrategy implements RouteReuseStrategy {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return null;
    }

    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        if (hasRouterError) {
            hasRouterError = false;

            return false;
        }

        return future.routeConfig === curr.routeConfig;
    }
}
